export default __webpack_public_path__ + "static/media/thanos_reverse_sound.0f371e57.mp3";